import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Events.css';
import EventsMain from './components/EventsMain';
import supabase from "../../supabaseClient";

const Events = () => {
  const [activeTab, setActiveTab] = useState('invited');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Keep selectedEvent in sync with the URL so /app/events/:eventId deep-links work
  useEffect(() => {
    const match = location.pathname.match(/\/app\/events\/([^/]+)/);
    const eventIdFromPath = match ? match[1] : null;

    if (!eventIdFromPath) {
      // No specific event in the URL, show the main events page
      setSelectedEvent(null);
      return;
    }

    if (selectedEvent && selectedEvent.id === eventIdFromPath) {
      // Already showing the correct event
      return;
    }

    let cancelled = false;

    const fetchEventById = async () => {
      try {
        const { data, error } = await supabase
          .from('events')
          .select('*')
          .eq('id', eventIdFromPath)
          .single();

        if (!error && data && !cancelled) {
          setSelectedEvent(data);
        }
      } catch {
        // If this fails, we simply stay on the main events view
      }
    };

    fetchEventById();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, selectedEvent]);

  const handleSelectEvent = (event) => {
    setSelectedEvent(event || null);
    if (event && event.id) {
      navigate(`/app/events/${event.id}`);
    } else {
      navigate('/app/events');
    }
  };

  const handleBack = () => {
    setSelectedEvent(null);
    navigate('/app/events');
  };

  return (
    <div className="events-page">
      <EventsMain
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        selectedEvent={selectedEvent}
        setSelectedEvent={handleSelectEvent}
        onBack={handleBack}
      />
    </div>
  );
};

export default Events;